import React from 'react';
import { Link } from 'react-router-dom';
import { BaseModal } from './BaseModal';

interface ShareInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ShareInfoModal({ isOpen, onClose }: ShareInfoModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="How We Share Information"
    >
      <div className="space-y-4 text-gray-600 dark:text-gray-300">
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl p-4 mb-6">
          <p className="text-yellow-800 dark:text-yellow-200 text-sm">
            This is a test website for demonstration purposes only. The information below is an example of how data sharing might be described in a privacy policy.
          </p>
        </div>

        <p>
          While we do not directly sell, rent, or loan your personally identifiable information, 
          we may share your information with companies, organizations, and individuals outside of 
          our organization as described below.
        </p>

        <p>
          We may share your information with our parent company or affiliates.
        </p>

        <p>
          We may share your information with Third Parties whom we work with to provide you a 
          seamless experience, to serve you relevant advertisements and to understand website usage.
        </p>

        <p>
          We may share non-identifiable or aggregate information with third parties for lawful purposes.
        </p>

        <p>
          At your direction or request, or when you otherwise consent, we may share your information.
        </p>

        <div className="mt-6">
          <Link 
            to="/privacy"
            className="text-[#5e9bb8] hover:text-[#499da8] dark:text-[#5e9bb8] dark:hover:text-[#499da8] transition-colors duration-200"
            onClick={onClose}
          >
            For more information, please visit our Online Privacy & Security Policy page
          </Link>
        </div>
      </div>
    </BaseModal>
  );
}